module.exports = __webpack_public_path__ + "static/media/loading-cube.eb8342ed.gif";